import { states, type StatesListResponse } from '@fireflyhealth/api'

import { useQuery } from '~/shared/hooks/query'

async function getStates(): Promise<StatesListResponse> {
  const response = await states.list()
  return response.data
}

/** Every US state the backend recognises, for any form that asks a member where they live. */
export const useStates = () => {
  return useQuery(
    states.listQueryKey(),
    () => getStates(),
    {},
    {
      error: `Unable to fetch states`,
    },
  )
}
